import { render } from "./Contemporaries.vue?vue&type=template&id=01c21c1f&scoped=true"
import script from "./Contemporaries.vue?vue&type=script&lang=js"
export * from "./Contemporaries.vue?vue&type=script&lang=js"

import "./Contemporaries.vue?vue&type=style&index=0&id=01c21c1f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-01c21c1f"

export default script